import React from 'react';

function EtusivuSection() {
  return (
    <>
      <p> Pulina on helppo ja lämminhenkinen tapa tutustua uusiin ihmisiin ilman paineita. Se on digitaalinen olohuone,
        jossa suomalaiset voivat vaihtaa ajatuksia arjesta, unelmista, työstä, opinnoista, harrastuksista ja ihan tavallisista
        päivän pienistä hetkistä. Täällä ei tarvitse huutaa tullakseen kuulluksi, eikä keskustelu huku
        loputtomaan uutisvirtaan.</p>
      <p>Haluatko jakaa ajatuksia vanhemmuudesta, opiskelusta, yrittäjyydestä tai uudesta harrastuksesta?
        Kaipaatko seuraa iltakävelylle, ajatusten vaihtoon tai juttukaveria aamukahvin ajaksi? Voit valita kevyen
        pikapulinan, spontaanin kahvitaukokeskustelun tai syvemmän ja pidemmän ajatustenvaihdon – 
        juuri silloin kun sinulle sopii.</p>
      <p> Pulina on suunniteltu ihmisen kokoiseksi. Me emme tavoittele loputonta selailua tai tykkäyskilpailuja,
        vaan aitoja kohtaamisia. Keskustelut saavat elää hetkessä ja myös kadota ajallaan, jotta voit jutella rennosti
        ilman painetta täydellisestä profiilista tai pysyvästä digitaalisesta jalanjäljestä. Tärkeintä on läsnäolo.</p>
    </>
  );
}

export default EtusivuSection;

